import { render, staticRenderFns } from "./order_supermarket.vue?vue&type=template&id=6de6a3c5&"
import script from "./order_supermarket.vue?vue&type=script&lang=js&"
export * from "./order_supermarket.vue?vue&type=script&lang=js&"
import style0 from "./order_supermarket.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports